import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";

import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";

const { post } = request;
const initialRoute = "employer";
const { Authorization, Bearer } = AUTHORIZATION;

export const postPremiumRecalculationForm = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		// const endpoint = `${initialRoute}/premium-recalculation/post-premium-recalculation`;
		const endpoint = `${initialRoute}/premium-recalculation/dynamic-post-premium-recalculation`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		// console.log("API-RESPONSE", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const postPremiumValidationForm = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/premium-recalculation/dynamic-post-premium-validation`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		// console.log("API-RESPONSE", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
